// extracted by mini-css-extract-plugin
module.exports = {"embedWrapper":"TemplateBlock_embedWrapper__b0Gnf"};